import { createContext } from "react";

export type AppShellBreadcrumbItem = {
  label: string;
  to?: string;
  loading?: boolean;
};

export type AppShellBreadcrumbContextValue = {
  items: AppShellBreadcrumbItem[];
  setItems: (items: AppShellBreadcrumbItem[]) => void;
};

export const AppShellBreadcrumbContext = createContext<AppShellBreadcrumbContextValue | null>(null);
